import * as auth from "store/actions/auth";

const initialState = {
  user: {},
  status: auth.STATUS_NOTLOGGED,
  error: false,
  errorMessage: null,
  employee: {
    data: {},
    status: auth.STATUS_NOTLOGGED,
    error: false,
    errorMessage: null,
  },
};

function appReducer(state = initialState, action) {
  switch (action.type) {
    case auth.ACTION_LOGIN:
      return {
        ...state,
        user: {},
        status: auth.STATUS_LOGGING,
        error: false,
        errorMessage: null,
      };
    case auth.ACTION_LOGIN_SUCCESS:
      return {
        ...state,
        user: action.user,
        status: auth.STATUS_LOGGED,
        error: false,
        errorMessage: null,
      };
    case auth.ACTION_LOGIN_ERROR:
      return {
        ...state,
        user: {},
        status: auth.STATUS_NOTLOGGED,
        error: true,
        errorMessage: action.error,
      };

    case auth.ACTION_EMPLOYEE_LOGIN:
      return {
        ...state,
        employee: {
          data: {},
          status: auth.STATUS_LOGGING,
          error: false,
          errorMessage: null,
        },
      };

    case auth.ACTION_EMPLOYEE_LOGIN_SUCCESS:
      return {
        ...state,
        employee: {
          data: action.user,
          status: auth.STATUS_LOGGED,
          error: false,
          errorMessage: null,
        },
      };

    case auth.ACTION_EMPLOYEE_LOGIN_ERROR:
      return {
        ...state,
        employee: {
          data: {},
          status: auth.STATUS_NOTLOGGED,
          error: true,
          errorMessage: action.error,
        },
      };

    case auth.ACTION_EMPLOYEE_LOGOUT:
      return {
        ...state,
        employee: {
          data: {},
          status: auth.STATUS_NOTLOGGED,
          error: false,
          errorMessage: null,
        },
      };

    case auth.ACTION_LOGOUT:
      return initialState;

    case auth.ACTION_CLEAR_ERROR:
      return {
        ...state,
        error: false,
        errorMessage: null,
        employee: {
          ...state.employee,
          error: false,
          errorMessage: null,
        },
      };

    default:
      return state;
  }
}

export default appReducer;
